import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-plum text-white" data-id="element-53" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-54" data-mp="3ggtwodvnbb34">
        <p className="font-display text-xl font-black text-white" data-id="element-55" data-mp="32pp764lzrz6i">
          SIGMA SMART<span className="align-super text-xs" data-id="element-56" data-mp="36q92r3qx2uqj">™</span> — THE 100 LEGAL PRECEDENTS AI<span className="align-super text-xs" data-id="element-57" data-mp="3ueih5klswg7n">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape-soft" data-id="element-58" data-mp="3ud7ddkscv8gj">
          🏥 “Your last late-night drafting session ends today.”
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-59" data-mp="3ldu2qoshwdu8">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-60" data-mp="3qfjighqnxfon">
            <MailIcon className="h-4 w-4 text-blush" data-id="element-61" data-mp="2eyjoziskwut1" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-62" data-mp="3l8qxg7f96pt1">
            <InstagramIcon className="h-4 w-4 text-blush" data-id="element-63" data-mp="3gc0f1dfz7i4g" /> @sigmasmart.en
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-64" data-mp="3v9az3b6opwbs">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-65" data-mp="3q726wh1myyaq">
            Terms & Conditions
          </a>
          <span data-id="element-66" data-mp="33xbprfttmpc">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-67" data-mp="34gtn85h8b3d">
            Privacy Policy
          </a>
          <span data-id="element-68" data-mp="hsacd1puztq6">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-69" data-mp="huwlv6wb8jb1">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/45" data-id="element-70" data-mp="qt015lgpcjue">
          © 2026 SIGMA SMART™ — All rights reserved.
        </p>
      </div>
    </footer>;
}